import React, { useEffect, useState, useRef } from "react";
import OwlCarousel from "react-owl-carousel";
import SkillItem from "./SkillItem";
import {
  getSkillsFromStore,
  getDraftSkills,
  getTrendingSkills,
  getPopularSkills,
  getAllSkillSet,
} from "../../../../redux/actions/skill";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../components/loader";

import navIcon from "../../../../images/nav-icon.svg";
const options = {
  // loop: true,
  margin: 15,
  nav: true,
  navText: [
    `<div class='sk-slide-nav owl-prev'><img src=${navIcon} /></div>`,
    `<div class='sk-slide-nav owl-next'><img src=${navIcon} /></div>`,
  ],
  dots: false,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 3,
    },
    1000: {
      items: 3,
    },
  },
};

const SkillsHubHome = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const mostPopular = useSelector(
    (state) => state.skillReducer?.mostPopular?.results
  );
  const trending = useSelector(
    (state) => state.skillReducer?.trending?.results
  );
  const popularSkillSet = useSelector(
    (state) => state.skillReducer?.allSkillSet?.results
  );

  return (
    <div>
      {mostPopular?.length ? (
        <div className="sk-slide-section">
          <div className="sk-slide-title">
            <h4 className="tp-title">Most Popular Agents</h4>
            {mostPopular?.length > 4 ? (
              <a
                onClick={() => {
                  history.push(
                    "/dashboard/skill-store/skill-collection/mostpopular"
                  );
                }}
              >
                View all
              </a>
            ) : (
              ""
            )}
          </div>
          <OwlCarousel
            className="owl-theme sk-boxes"
            id="sk-boxes1"
            {...options}
          >
            {mostPopular?.map((skill, index) => (
              <SkillItem item={skill} key={index} opt={false} />
            ))}
          </OwlCarousel>
        </div>
      ) : null}

      {/* Skill Sets */}
      {/* {popularSkillSet?.length ? (
        <div className="sk-slide-section">
          <div className="sk-slide-title">
            <h4 className="tp-title">Most Popular Agents</h4>
            {popularSkillSet?.length > 1 ? (
              <a
                onClick={() => {
                  history.push(
                    "/dashboard/skill-store/skill-collection/mostpopular-skillsets"
                  );
                }}
              >
                View all
              </a>
            ) : (
              ""
            )}{" "}
          </div>
          <OwlCarousel
            className="owl-theme sk-boxes"
            id="sk-boxes1"
            {...options}
          >
            {popularSkillSet?.map((skill, index) => (
              <SkillItem item={skill} key={index} opt={false} />
            ))}
          </OwlCarousel>
        </div>
      ) : null} */}
      {/* End of Skill Sets */}
      {trending?.length ? (
        <div className="sk-slide-section">
          <div className="sk-slide-title">
            <h4 className="tp-title">Automation Trending Agents</h4>

            {trending?.length > 4 ? (
              <a
                onClick={() => {
                  history.push(
                    "/dashboard/skill-store/skill-collection/automation-trending"
                  );
                }}
              >
                View all
              </a>
            ) : (
              ""
            )}
          </div>
          <OwlCarousel
            className="owl-theme sk-boxes"
            id="sk-boxes1"
            {...options}
          >
            {trending.map((skill, index) => (
              <SkillItem item={skill} key={index} opt={true} />
            ))}
          </OwlCarousel>
        </div>
      ) : null}
    </div>
  );
};

export default SkillsHubHome;
